export default "__VITE_ASSET__CDZSc1Rd__"